
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, FileText, ExternalLink } from "lucide-react";
import { platformTechKnowledgeBases } from "@/utils/knowledgeBases";

const PlatformTechPage = () => {
  const navigate = useNavigate();
  const [selectedKb, setSelectedKb] = useState<typeof platformTechKnowledgeBases[0] | null>(null);

  const handleBack = () => {
    navigate("/ispai-channel");
  };

  const handleOpenPdf = (kb: typeof platformTechKnowledgeBases[0]) => {
    window.open(kb.url, "_blank");
  };

  return (
    <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Button 
          variant="outline" 
          className="mb-6 flex items-center gap-2"
          onClick={handleBack}
        >
          <ArrowLeft className="h-4 w-4" /> 
          Back to iSPAI Channel
        </Button>

        <Card className="mb-6">
          <CardHeader>
            <CardTitle className="text-2xl font-bold flex items-center gap-2">
              <span className="text-primary bg-primary/10 p-2 rounded-md">PlTc</span>
              Platform Tech Domain
            </CardTitle>
            <CardDescription className="text-lg mt-2">
              Blockchain Attribution, LLM Integration, API Ecosystem, Collaboration Tools, Security
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="grid grid-cols-1 gap-4">
              {platformTechKnowledgeBases.map((kb, index) => (
                <div 
                  key={index} 
                  className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer"
                  onClick={() => handleOpenPdf(kb)}
                >
                  <div className="flex items-start gap-4">
                    <div className="bg-primary/10 p-3 rounded-md">
                      <FileText className="h-6 w-6 text-primary" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-medium flex items-center gap-2">
                        {kb.title}
                        <ExternalLink className="h-4 w-4 text-gray-400" />
                      </h3>
                      <p className="text-sm text-gray-500 mt-1">{kb.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 text-blue-700 text-sm">
              <p className="font-medium mb-2">Note:</p>
              <p>These knowledge base items link to actual PDF documents in the SharePoint content management system.</p>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default PlatformTechPage;
